module.exports = __webpack_public_path__ + "img/uzbekistn.4a34d02a.png";